import API from "./API";

class CoverageService {
  api: API = null;

  constructor(api: API) {
    this.api = api;
  }

  async verifyCoverage(payload: {
    policyNumber: string;
    insuredName: string;
    dailyAttendance: number;
    venueZip: string;
    issuedZip: string;
    coverageKey: string;
    captcha?: string;
  }) {
    return this.api.post({
      location: "/coverage/verification",
      body: payload,
    });
  }
}

export default CoverageService;
